import React from 'react'

import {TableHeaderRow} from "@devexpress/dx-react-grid-material-ui"
import {Filter} from "../Filter"

export const TableHeaderContent = (props) => {
    const {column, children, ...restProps} = props

    let button = null

    switch (column.name) {
        case 'name':
        case 'count':
        case 'created':
        case 'updated':
            button = <Filter name={column.name}/>
            break
        case 'number':
        default:
            break
    }

    return (
        <TableHeaderRow.Content
            column={column}
            {...restProps}
            style={{
                justifyContent: 'space-between'
            }}
        >
            {children}
            {button}
        </TableHeaderRow.Content>
    )
}
